import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/components/Home.vue')
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: () => import('@/components/Calendar.vue')
    },
    {
      path: '/community/:filterTag?',
      component: () => import('@/components/Community.vue'),
      children: [
        {
          path: 'equipment',
          name: 'Equipment',
          component: () => import('@/components/Equipment.vue')
        },
        {
          path: '',
          name: 'Community',
          component: () => import('@/components/portfolio/BlogList.vue')
        },
        {
          path: 'blog/:year/:month/:blogId',
          name: 'Community-Blog',
          component: () => import('@/components/portfolio/Blog.vue')
        }]
    },
    {
      path: '/portfolio/:filterTag?',
      component: () => import('@/components/Portfolio.vue'),
      children: [
        {
          path: '',
          name: 'Portfolio',
          component: () => import('@/components/portfolio/BlogList.vue')
        },
        {
          path: 'blog/:year/:month/:blogId',
          name: 'Portfolio-Blog',
          component: () => import('@/components/portfolio/Blog.vue')
        }]
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/components/Contact.vue')
    },
    {
      path: '/mixer',
      alias: ['/facebook-gaming'],
      name: 'Mixer',
      component: () => import('@/components/Mixer.vue')
    },
    {
      path: '/redirect/*',
      name: 'Redirect',
      component: () => import('@/components/Redirect.vue')
    },
    {
      path: '/of',
      name: 'OnlyFans',
      component: () => import('@/components/OnlyFans.vue')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/components/_404.vue')
    },
    {
      path: '*',
      redirect: to => {
        // Handle dynamic redirects
        /* eslint-disable */
        var redirects = _redirects !== undefined ? _redirects : null
        if (redirects !== null) {
          for (var i = 0; i < redirects.length; i++) {
            if (to.path.toLowerCase() === redirects[i].path.toLowerCase() || to.path.toLowerCase() === redirects[i].path.toLowerCase() + '/') {
              window.location.replace(redirects[i].redirect)
              return 'redirect' + to.path.toLowerCase()
            }
          }
        }
        Vue.$ga.page('/404' + to.path.toLowerCase())
        return '/404'
        /* eslint-enable */
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js